<script>
import options from './NykBanner.options'

export default options
</script>

<template>
    <NykBasicCard
        class="nyk-context-banner"
        :role="role"
        :style="backgroundColor ? { backgroundColor } : undefined">
        <div class="nyk-context-banner__content">
            <div class="nyk-context-banner__content__info">
                <p class="nyk-context-banner__content__info__description">{{ message }}</p>
            </div>
        </div>
        <button
            v-if="dismissible"
            class="nyk-context-banner__link"
            type="button"
            :aria-label="dismissLabel"
            @click="$emit('dismiss')"></button>
    </NykBasicCard>
</template>